import { useNavigate } from "react-router-dom";

export const useContractorNavigation = () => {
  const navigate = useNavigate();

  const redirectContractor = (notification: any) => {
    const { object_id, object_type, project_id, task_id } = notification;

    // Standardized params for all contractor drawer types
    const params = new URLSearchParams();
    if (notification.object_type === "task") {
      params.set("selected", "true");
      params.set("taskId", object_id);
    } else {
      params.set("isOpen", "true");
      params.set("objectType", object_type);
      params.set("objectId", String(object_id));
      params.set("projectId", String(project_id));
      if (task_id) {
        params.set("taskId", String(task_id));
      }
    }

    navigate(`/tasks?${params.toString()}`);
  };
  return { redirectContractor };
};
